import * as React from 'react';
import { ChevronDown } from 'lucide-react';

import { mergeClassNames } from './class-names';

export interface SelectProps extends React.ComponentProps<'select'> {
  containerClassName?: string;
}

/** Native selection with one shared owner for arrow placement and text clearance. */
export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ children, className, containerClassName, ...props }, ref) => (
    <span
      className={mergeClassNames(
        'relative block w-full min-w-0',
        containerClassName,
      )}
    >
      <select
        ref={ref}
        className={mergeClassNames(
          'peer flex h-12 w-full cursor-pointer appearance-none overflow-hidden text-ellipsis whitespace-nowrap rounded-2xl border border-stone-200 bg-white py-2 pl-4 pr-12 text-base text-stone-950 shadow-sm outline-none transition motion-reduce:transition-none',
          'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
          'focus-visible:border-emerald-300 focus-visible:ring-4 focus-visible:ring-emerald-100',
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden="true"
        focusable="false"
        className="pointer-events-none absolute right-4 top-1/2 size-5 -translate-y-1/2 text-stone-500 transition-colors motion-reduce:transition-none peer-disabled:opacity-40 peer-focus-visible:text-stone-900"
        strokeWidth={2.25}
      />
    </span>
  ),
);

Select.displayName = 'Select';
